import React, { useEffect, useState } from "react";
import ChattingInput from "./ChattingInput";
import ChattingArea from "./ChattingArea";
import styled, { css } from "styled-components";
import { useChattingRoomFromContext } from "@src/contexts/ChattingRoomContext";
import { SnackbarStyle } from "../chattingRoomInfo/MatchTakerButtons";
import { CompleteRequestStatus, MatchStatusType, useGetChattingRoomInfo } from "@src/hooks/auctionAgent/chat";

const ChattingChannel = () => {
    const { chattingRoomFromContext } = useChattingRoomFromContext();
    const { data: chattingRoomInfo } = useGetChattingRoomInfo(
        chattingRoomFromContext?.chattingRoomNo ?? 0,
        !!chattingRoomFromContext?.chattingRoomNo && chattingRoomFromContext?.chattingRoomNo !== 0,
    );

    const [showConfirmSnackbar, setShowConfirmSnackbar] = useState(false);
    const [isHiding, setIsHiding] = useState(false);

    useEffect(() => {
        if (!showConfirmSnackbar) {
            setTimeout(() => {
                setShowConfirmSnackbar(true);
            }, 1000);
        }
    }, []);

    useEffect(() => {
        if (showConfirmSnackbar) {
            const timer = setTimeout(() => {
                setIsHiding(true);
                setTimeout(() => {
                    setShowConfirmSnackbar(false);
                    setIsHiding(false);
                }, 300);
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [showConfirmSnackbar]);

    if (!chattingRoomFromContext) return null;

    return (
        <ChattingChannelBox
            isMatchRequest={chattingRoomInfo?.item.status === MatchStatusType.매치신청}
            isCompleteRequest={
                chattingRoomFromContext?.user.userType === "user" &&
                chattingRoomInfo?.item.completeRequestStatus === CompleteRequestStatus.완료대기
            }
        >
            <ChattingArea chattingRoomNo={chattingRoomFromContext?.chattingRoomNo} userId={chattingRoomFromContext.user.userId} />
            <ChattingInput chattingRoomNo={chattingRoomFromContext?.chattingRoomNo} />
            {showConfirmSnackbar && <SnackbarStyle className={isHiding ? "hide" : ""}>채팅방에 입장했어요!</SnackbarStyle>}
        </ChattingChannelBox>
    );
};

export default ChattingChannel;

const ChattingChannelBox = styled.div<{ isMatchRequest: boolean; isCompleteRequest: boolean }>`
    width: 100%;
    padding: 14px;
    height: calc(100vh - 274px);
    background-color: #becdde;
    ${({ isMatchRequest }) =>
        isMatchRequest &&
        css`
            height: calc(100vh - 244px);
        `}
    ${({ isCompleteRequest }) =>
        isCompleteRequest &&
        css`
            height: calc(100vh - 324px);
        `}
`;
